module.exports = __webpack_public_path__ + "static/media/camper.45fecee4.jpg";